import { $el } from 'src/scripts/utils/utils'
import { hexToColorName } from '../../utils/color'
import { BaseComponent } from '../base-component'

const SWATCH_SELECTOR = '.color-swatch'

export class ShapeSwatch extends BaseComponent {
  element: any

  constructor() {
    super()
    this.element = $el(SWATCH_SELECTOR, this) || this
    this.setValue()
  }

  setValue(): void {
    if (this.hasAttribute('is-image')) {
      return
    }

    const selectedValue = this.dataset.color.toLowerCase().trim()
    const patterns = this.dataset.colorsPatterns.split('\n')
    const isValidColor = this.isColor(selectedValue)

    if (!isValidColor) {
      this.element.setAttribute('not-valid', '')
    }

    this.setPropertyValue(selectedValue)

    patterns.forEach(pattern => {
      const config = pattern.split('::')
      const patternLabel = config[0]
      const patternValue = config[1]

      const patternLabelDowncase = patternLabel.toLowerCase().trim()

      if (patternLabelDowncase === selectedValue) {
        this.setPropertyValue(patternValue)

        return
      }
    })
  }

  getGradientValue(colors) {
    let gradientValue = '90deg, '
    let notValidColor = 0

    const patterns = this.dataset.colorsPatterns.split('\n')

    const preparedPatterns = patterns.reduce((acc, pattern) => {
      const config = pattern.split('::')
      const patternLabel = config[0]
      const patternValue = config[1]

      const patternLabelDowncase = patternLabel.toLowerCase().trim()

      return { ...acc, [patternLabelDowncase]: patternValue }
    }, {})

    colors.forEach((gradientColor, index) => {
      const percent = 100.0 / colors.length

      let color = gradientColor.toLowerCase()

      if (preparedPatterns[color]) {
        color = preparedPatterns[color]
      } else if (!this.isColor(color)) {
        color = 'white'

        notValidColor += 1
      }

      const startPoint = `${percent * index}%`
      const endPoint = `${percent * (index + 1)}%`
      const pointValue = `${color} ${startPoint}, ${color} ${endPoint}`

      gradientValue = `${gradientValue} ${pointValue}`

      if (index !== colors.length - 1) {
        gradientValue = `${gradientValue}, `
      }
    })

    return notValidColor === colors.length
      ? null
      : `linear-gradient(${gradientValue})`
  }

  setPropertyValue(value: string) {
    const isImage = this.isImage(value)
    const isUrl = this.isUrl(value)
    const isGradient = this.isGradient(value)
    const isValidColor = this.isColor(value)

    const bgColorHex = this.dataset.sectionBackground
    const bgColorName = hexToColorName(bgColorHex)

    if (isUrl) {
      this.element.removeAttribute('not-valid')
      this.element.style.setProperty(
        '--gsc-color-swatch-value',
        `url(${value})`,
      )

      this.setSimilarlyBgColorStatus(false)
    } else if (isImage) {
      // this.element.style.setProperty('--gsc-color-swatch-value', ``)

      this.setSimilarlyBgColorStatus(false)
    } else if (isGradient) {
      const gradientColors = value.split('/')
      const gradientValue = this.getGradientValue(gradientColors)
      const isSimilarlyBgColor =
        value.includes(bgColorHex) || value.includes(bgColorName)

      if (gradientValue) {
        this.element.removeAttribute('not-valid')
        this.element.style.setProperty(
          '--gsc-color-swatch-value',
          gradientValue,
        )
      }

      this.setSimilarlyBgColorStatus(isSimilarlyBgColor)
    } else {
      const isSimilarlyBgColor = value === bgColorHex || value === bgColorName

      if (isValidColor) {
        this.element.removeAttribute('not-valid')
      }

      this.setSimilarlyBgColorStatus(isSimilarlyBgColor)
      this.element.style.setProperty('--gsc-color-swatch-value', value)
    }
  }

  setSimilarlyBgColorStatus(isSimilarlyBgColor: boolean): void {
    this.element.toggleAttribute(
      'section-background-color-equally',
      isSimilarlyBgColor,
    )
  }

  isColor(color: string): boolean {
    const style = new Option().style

    style.color = color

    return style.color !== ''
  }

  isImage(value: string): boolean {
    return value.includes('.png') || value.includes('.jp')
  }

  isUrl(value: string): boolean {
    try {
      new URL(value)
      return true
    } catch (err) {
      return false
    }
  }

  isGradient(value: string): boolean {
    return value.includes('/')
  }
}
